<template>
  <section class="container-sarah">
    <breadcrumb route="/inicio" :title="this.$t('areas.home')" />
    <!-- Intro Text -->
    <div class="hero">
      <div class="hero-body">
        <h1 class="title">
          {{ $t('documentos.titulo') }}
        </h1>
        <p class="info_subtitle">
          {{ $t('documentos.subtitulo') }}
        </p>
      </div>
    </div>

    <b-tabs v-model="activeTab" class="view-desktop tab-navigation">
      <b-tab-item :label="this.$t('documentos.atestados.titulo')">
        <Atestados />
      </b-tab-item>
      <b-tab-item :label="this.$t('documentos.laudos.titulo')">
        <Relatorios />
      </b-tab-item>
      <b-tab-item :label="this.$t('documentos.receitas.titulo')">
        <Receitas />
      </b-tab-item>
      <b-tab-item :label="this.$t('documentos.outros-servicos.titulo')">
        <Servicos />
      </b-tab-item>
    </b-tabs>

    <div class="view-mobile">
      <div class="form-template general-forms">
        <responsive-tab
          :data="optionData"
          v-model="option"
          @switchInfo="updateInfo($event)"
        />
        <br />
        <div v-if="info === 'Atestados'">
          <Atestados />
        </div>
        <div v-if="info === 'Relatorios'">
          <Relatorios />
        </div>
        <div v-if="info === 'Receitas'">
          <Receitas />
        </div>
        <div v-if="info === 'Servicos'">
          <Servicos />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from '../components/shared/breadcrumb/Breadcrumb'
import Receitas from '@/components/documents/Receitas'
import ResponsiveTab from '@/components/shared/tabs/ResponsiveTab'
import Relatorios from '@/components/documents/Relatorios'
import Atestados from '@/components/documents/Atestados'
import Servicos from '@/components/documents/OutrosServicos'
import { mapMutations, mapGetters } from 'vuex'
import * as MutationTypes from '@/store/modules/mutation-types.js'
import router from '@/router'

export default {
  name: 'Documentos',
  components: {
    Breadcrumb,
    Receitas,
    Servicos,
    Atestados,
    Relatorios,
    ResponsiveTab
  },
  data() {
    return {
      activeTab: 0,
      info: 'Atestados',
      option: 'Atestados',
      optionData: [
        { label: 'Atestados', initial: 'Atestados' },
        { label: 'Laudos e relatórios médicos', initial: 'Relatorios' },
        { label: 'Receitas', initial: 'Receitas' },
        { label: 'Formulários e outros serviços', initial: 'Servicos' }
      ],
      data: [
        { label: 'Atestados' },
        { label: 'Laudos e relatórios médicos' },
        { label: 'Receitas' },
        { label: 'Formulários e outros serviços' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      paciente: 'dadosPaciente'
    })
  },
  beforeMount: function () {
    this.INIT_DATE_FILTER(null)
    this.END_DATE_FILTER(null)
    this.VerificarUsuario()
  },
  methods: {
    ...mapMutations([
      MutationTypes.INIT_DATE_FILTER,
      MutationTypes.END_DATE_FILTER
    ]),
    updateInfo(info) {
      this.info = info
    },
    VerificarUsuario() {
      if (this.paciente == null) {
        router.push({ path: '/', query: { returnUrl: this.$route.path } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/forms';

.form-template.general-forms .dropdown {
  .dropdown-trigger {
    width: 100%;
  }

  .dropdown-menu {
    width: 100%;
  }
}

.hero-body {
  padding-left: 0;
  padding-right: 0;
}

.tabs ul {
  li {
    width: 33.33%;
    margin-bottom: 3.4375rem;
  }
}

.tab-navigation {
  padding-left: 0;
  padding-right: 0;
}
@media (max-width: 64rem) {
  .form-template.general-forms {
    .select-form .dropdown {
      .dropdown-trigger {
        width: 100%;
      }
      .dropdown-menu {
        width: 100%;
      }
    }
  }
}
</style>
